import { useTranslation } from 'react-i18next'

import { Stack, Text } from '@enechain/ecloud-designsystem'

import { ConfirmDialog } from '~/components/common/ConfirmDialog'
import type { AreaChangeConfirmation } from '~/models/areaChange'

type Props = {
  confirmation: AreaChangeConfirmation
  isLoading: boolean
  onConfirm: () => void
  onCancel: () => void
}

/**
 * エリア変更の確認ダイアログ: 変更後のエリアと食い違うユニットを並べ、もう片方を直す画面を案内する。
 * 「変更する」で確認済みの印を付けて保存を送り直す。
 */
export const AreaChangeConfirmDialog = ({
  confirmation,
  isLoading,
  onConfirm,
  onCancel,
}: Props): React.ReactElement => {
  const { t } = useTranslation()
  return (
    <ConfirmDialog
      body={
        <Stack gap={2}>
          <Text>{confirmation.description}</Text>
          <Stack as="ul" gap={1} paddingLeft={4}>
            {confirmation.units.map((unit) => (
              <Text key={unit} as="li">
                {unit}
              </Text>
            ))}
          </Stack>
        </Stack>
      }
      confirmLabel={t('page:adminPlantUnitMaster.areaChange.confirmButton')}
      isLoading={isLoading}
      isOpen
      onCancel={onCancel}
      onConfirm={onConfirm}
      title={confirmation.title}
    />
  )
}
